import axios, { AxiosResponse } from 'axios'
import { ExportCommonParams } from '@/api/resources/common/shared/models/common.models'
import { ReportGridRequest } from '@/api/services/common.dto'

class ShipmentsRequestExporterService {
    async exportPendingToBeSent(
        originLaboratoryId: number,
        gridColumns?: ReportGridRequest,
        params?: ExportCommonParams
    ): Promise<AxiosResponse<Blob>> {
        return axios.put<Blob>(
            `/shipments/laboratories/${originLaboratoryId}/shipmentRequests/export`,
            { ...gridColumns },
            { params, responseType: 'arraybuffer' })
    }
}

export const shipmentsRequestExporterService = new ShipmentsRequestExporterService()
